import { Icon } from "@circle-react-shared/Icon";
import { Typography } from "@circle-react-shared/uikit/Typography";
import { t } from "@/i18n-js/instance";
import { usePunditUserContext } from "@circle-react/contexts";

export const BlockedMemberBadge = () => {
  const { currentCommunitySettings } = usePunditUserContext();
  const isBlockDMsEnabled =
    currentCommunitySettings?.live_pulse_block_dms_enabled;

  if (!isBlockDMsEnabled) {
    return null;
  }
  return (
    <div className="border border-feedback-error rounded-lg px-2 py-0.5 items-center justify-center flex gap-1 bg-[#EF44441A]/10">
      <Icon type="16-circle-x" size={16} className="text-feedback-error !w-4" />
      <Typography.LabelXs
        weight="medium"
        color="text-feedback-error"
        data-testid="member-blocked"
      >
        {t("profile_drawer.blocked_dms")}
      </Typography.LabelXs>
    </div>
  );
};
